import { render } from "./external-patient-show.vue?vue&type=template&id=577f5732&scoped=true"
import script from "./external-patient-show.vue?vue&type=script&lang=js"
export * from "./external-patient-show.vue?vue&type=script&lang=js"

import "./external-patient-show.vue?vue&type=style&index=0&id=577f5732&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577f5732"]])

export default __exports__